import Types from "../types";

export function onProfileObjChange(profileObj) {
  return { type: Types.PROFILEOBJ, profileObj: profileObj };
}

export function onHistoryObjChange(historyObj) {
  return { type: Types.HISTORYOBJ, historyObj: historyObj };
}

export function onAuthorizationChange(authorization) {
  return { type: Types.AUTHORIZATION, authorization: authorization };
}

export function onSubscriptionChange(subscription) {
  return { type: Types.SUBSCRIPTION, subscription: subscription };
}
